// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  height: 20px;
  margin: 10px;
  border: solid 1px
    ${({ $isChecked, theme }) => ($isChecked ? theme.grids.colors.yellow : theme.grids.colors.darkgrey5)};
  position: relative;
  border-radius: 12px;
  cursor: pointer;
  box-sizing: content-box;
  display: inline-block;
  transition:
    background-color 0.2s,
    border-color 0.2s;
`;

const Bullet = styled.div`
  position: absolute;
  display: block;
  top: -6px;
  left: -10px;
  width: 30px;
  height: 30px;
  min-width: 30px;
  max-width: 30px;
  min-height: 30px;
  max-height: 30px;
  border-radius: 50%;
  box-shadow: none;
  padding: 0;
  transform-origin: center center;
  border: solid 1px ${({ $isChecked, theme }) => ($isChecked ? theme.grids.colors.yellow : '#979797')};
  background-color: ${({ $isChecked, theme }) => ($isChecked ? theme.grids.colors.yellow : theme.grids.colors.black)};
  transition: transform 0.2s;
  transform: translate3d(${({ $isChecked }) => ($isChecked ? '30px' : 0)}, 0, 0);
`;

type Props = {
  className?: string;
  isChecked: boolean;
  onClick?: () => void;
  'data-testid'?: string; // to pass data-testid via styled-components :(
};

const Toggle = (props: Props) => {
  const { className, isChecked, onClick } = props;
  return (
    <Wrap $isChecked={isChecked} onClick={onClick} className={className} data-testid={props['data-testid']}>
      <Bullet $isChecked={isChecked} />
    </Wrap>
  );
};

export default Toggle;
